export default __webpack_public_path__ + "static/media/emag.ccd0d028.jpg";